export default __webpack_public_path__ + "static/lead-bg--mobile@1x-2b532d134c15671921f37d7cc592b407.jpg";